import { AuthenticatedLayout } from "../../../layouts";
import { WSIBReport } from "../../../components/Reports/WSIBReport";
import { FC } from "react";

export interface IWSIBReportSetupPage {}

export const WSIBReportPage: FC<IWSIBReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="WSIB Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<WSIBReport />}
		/>
	);
};
